import { PosEnumSelect, PosEnumSelectProps } from 'src/core/POS/PosSelect';
import { TAG_VALUE_INHERIT_MODE_TO_CID } from 'src/utils/constants/contentIdMaps';
import { TagValueInheritMode } from 'src/WebApiController';

export type TagValueInheritModeSelectorProps = Omit<
  PosEnumSelectProps<TagValueInheritMode>,
  'valueOptionsContent'
> & {
  valueOptionsContent?: Record<TagValueInheritMode, string>;
};

export const TagValueInheritModeSelector = ({
  valueOptionsContent,
  ...rest
}: TagValueInheritModeSelectorProps) => {
  return (
    <PosEnumSelect
      style={{ width: '100%' }}
      {...rest}
      enableEmptySelection={false}
      valueOptionsContent={valueOptionsContent ?? TAG_VALUE_INHERIT_MODE_TO_CID}
      sortMode="none"
    />
  );
};
